import React from "react";
import NotInterestedIcon from '@material-ui/icons/NotInterested';

function Forbidden() {
    return (
        <>
            <div>
                <h1>Acceso Denegado</h1>
            </div>
        </>
    );
}

export function ForbiddenPage() {
    return (
        <>
            <div
                style={{
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column"
                }}
            >
                <h1>Mda Avellaneda</h1>
                <NotInterestedIcon style={{color: "red", fontSize: "20em"}}/>
                <h1>Acceso Denegado</h1>
            </div>
        </>
    );
}

export default Forbidden;
